import fotoEscura from "../../assets/fotoEscura.png";
import fotoClara from "../../assets/fotoClara.png";

export const themes = {
    light: {
      color: "#212529",
      background: "#F6F6F6",
      SidebarBackground: "#EAEAEA",
      foto: fotoClara,
    },
    dark: {
      color: "#f3f3f3",
      background: "#111111",
      SidebarBackground: "#2c2c2c",
      foto: fotoEscura,
    },
  };